module.exports = __webpack_public_path__ + "static/media/icon-arrow-orange-down.80d0246f.svg";